import React, { useCallback, useEffect, useRef, useState } from 'react';
import { mixGetV2, mixPostV2, mixDate, mixGetV3, formatNumber } from '../../services/mixin';
import Layout from '../../Layout';
import ColSetting from '../../components/Filter/ColSetting';
import { Input, Space, Pagination, Table, Button, Flex, Slider, SliderSingleProps, GetProp, TreeProps, Checkbox, Tree, CheckboxChangeEvent, Form, Radio, RadioChangeEvent, PaginationProps } from 'antd';
import {
  DeleteOutlined, UploadOutlined, SettingOutlined, EyeOutlined,
  DownOutlined,
  CloseCircleOutlined,
  UserOutlined,
  FilterOutlined,
  CloseOutlined
} from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';
import './CustomerList.scss';
import { Link, useNavigate } from 'react-router-dom';
import useToast from '../../hook/useToast';
import ModalDeleteManager from '../../components/ModalDeleteManager';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import ImportDataModal from './Component/ImportDataModal/ImportDataModalV1';
import MegaTable from './cpnMagaTable';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { table } from 'console';
import { findChildIdByUrl, fommatSelectOptionData, fommatSelectOptionUnitByUser, getTitleSelectOption } from '../../until';
import useThrottle from '../../hook/useThrottle';
import useDebounce from '../../hook/useDebounce';
import { dataGender, dataStatusMarital } from '../../services/data';
import { selectorMenu } from '../../store/slices/menuSlice';
import { selectorUnitByUserPermission } from '../../store/slices/UnitByUserPermission';
import { number } from 'echarts';
import * as customerApiSync from '../../apiSync/customer/customerApi';
import { getSLVehicleBrands } from '../../apiSync/selectOptions/selectOptionsApi';
// import { themeQuartz } from "ag-grid-community";


const nameTableCache = 'TbCachePoolingDateCustomerList';


export interface IDataDefaulFilterList {
  searchF?: string,
  age?: number[];
  gender?: string
  brand?: string
  vehicleOwned?: number
  ownershipPeriod?: number
}

export interface ISelectOption {
  value: string
  label: string
}

// filter cho bảng
const dataDefaulFilterList = {

} as IDataDefaulFilterList;


const dotuoi: SliderSingleProps['marks'] = {
  0: '0',
  18: '18',
  30: '30',
  100: '100',
};

const CustomerList: React.FC = () => {
  const { id } = useSelector(selectorInfoUser);
  const menuSlice = useSelector(selectorMenu)
  const pushToast = useToast();
  const navigate = useNavigate()

  const { add, download, delete: isdelete, share } = findChildIdByUrl(menuSlice, "/customer/list")
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission) // đơn vị của user đăng nhập

  useEffect(() => {
    return () => {
      setPagination({ current: 1, pageSize: 20, total: 0 })
      setDataFilterList(dataDefaulFilterList)
    }
  }, [])


  // TABLE COLUMNS
  const columns = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (_d: any, row: any) => (
        <Flex align='center' className='gap-10px'>
          <Button className="rs-button rs-button--icon-only" onClick={() => {
            navigate(`/customer/list/${row.warehouse_id_origin}?id_sync=${row.id}`);
          }}><EyeOutlined /></Button>
        </Flex>
      ),
    },
    {
      title: 'Mã định danh khách hàng',
      dataIndex: 'cus_id',
      key: 'cus_id',
    },
    {
      title: 'Họ tên',
      dataIndex: 'cus_name',
      key: 'cus_name',
    },
    {
      title: 'CCCD/CMND',
      dataIndex: 'cus_dms_id_card_no',
      key: 'cus_dms_id_card_no',
    },
    {
      title: 'Mã số thuế',
      dataIndex: 'cus_tax_reg_no_dms',
      key: 'cus_tax_reg_no_dms',
    },
    {
      title: 'Ngày sinh',
      dataIndex: 'cus_birth_day',
      key: 'cus_birth_day',
    },
    {
      title: 'Giới tính',
      dataIndex: 'cus_gender_name',
      key: 'cus_gender_name',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'cus_tel',
      key: 'cus_tel',
    },
    {
      title: 'Email',
      dataIndex: 'cus_email',
      key: 'cus_email',
    },
  ];

  useEffect(() => {

    const handleClickOutside = (event: any) => {

      if (event.target.matches('.content-select, .add-filter, .add-filter *, .show-access-filter, .show-access-filter *, .list-filter, .list-filter *, .ant-picker-dropdown, .ant-picker-dropdown, .show-edit-filter *,  .w-modal-242, .w-modal-242 *, .ant-modal-wrap') === false) {
        setIsModalAddFilter(false)
      }

    };

    const handleResize = () => {
      const baseFactor = (48 * 100) / 1440 / 100
      const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
      const newHeight = Math.round(window.innerWidth * factor)
      // setRowHeight(newHeight)
    }
    handleResize()

    window.addEventListener('resize', handleResize)
    document.addEventListener('click', handleClickOutside);

    return (() => {

      setPagination({ current: 1, pageSize: 20, total: 0 })
      setSelectedRowKeys([])

      setDataFilterList(dataDefaulFilterList)

      document.removeEventListener('click', handleClickOutside);
      window.removeEventListener('resize', handleResize)
    })
  }, [])


  // State
  const [isSettingShow, setSettingShow] = useState(false);


  const [openDeleteListCustomer, setOpenDeleteListCustomer] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [idCustomer, setIdCustomer] = useState<number>();
  const [loading, setLoading] = useState(true);
  const [megaTableData, setMegaTableData] = useState<any>({
    col: [],
    listData: [],
    open: false,
    loading: true,
  });
  const [tempColData, setTempColData] = useState<any[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [paramListData, setParamListData] = useState<any>({
    'sort[]': 'updated_at,desc',
    page: 1,
    limit: 10,
    keyword: '',
    source_id: null,
    list_key: '[]',
  });
  const [listData, setListData] = useState<any[]>([]);
  const [showImportDataModal, setShowImportDataModal] = useState(false);
  const [paramKeys, setParamKeys] = useState<any[]>([]);
  const [paramMap, setParamMap] = useState<any[]>([]);
  const [source, setSource] = useState<any[]>([]);

  // new Filter variable

  const [isModalAddFilter, setIsModalAddFilter] = useState(false);



  const [indeterminateProfession, setIndeterminateProfession] = useState<boolean>(false); // Trạng thái "một phần được chọn"
  const [checkAllProfession, setCheckAllProfession] = useState<boolean>(false); // Trạng thái "chọn tất cả"
  const [indeterminateHobby, setIndeterminateHobby] = useState<boolean>(false); // Trạng thái "một phần được chọn"
  const [checkAllHobby, setCheckAllHobby] = useState<boolean>(false); // Trạng thái "chọn tất cả"
  const [indeterminateGroupCustomer, setIndeterminateGroupCustomer] = useState<boolean>(false); // Trạng thái "một phần được chọn"
  const [checkAllGroupCustomer, setCheckAllGroupCustomer] = useState<boolean>(false); // Trạng thái "chọn tất cả"
  const [indeterminateUnit, setIndeterminateUnit] = useState<boolean>(false); // Trạng thái "một phần được chọn"
  const [checkAllUnit, setCheckAllUnit] = useState<boolean>(false); // Trạng thái "chọn tất cả"


  const [sLCarCompany, setSLCarCompany] = useState<string[]>([])

  const [dataFilterAdd, setDataFilterAdd] = useState<IDataDefaulFilterList>(dataDefaulFilterList)
  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const gSLVehicleBrands = async () => {
    setSLCarCompany([
      "BMW",
      "KIA",
      "MAZDA",
      "MINI",
      "MOTORRAD",
      "PEUGEOT",
      "PEUGEOT MTC",
      "TẢI TRUNG - BEN TRUNG",
      "XE BUS & MINI BUS",
      "XE TẢI NHẸ",
      "XE TẢI NẶNG - ĐẦU KÉO - BEN NẶNG"
    ])
    // const result = await getSLVehicleBrands()
    // if (result) {
    //   setSLCarCompany(result)
    // }
  }

  const gListCustomer = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoading(true)
    const {
      searchF, gender, brand, ownershipPeriod, vehicleOwned, age
    } = dataFilterList
    const ageFrom = age ? age[0] : undefined
    const ageTo = age ? age[1] : undefined

    const result = await customerApiSync.getListCustomerSync(
      pageCurent, pageSize, searchF, brand,
      gender, ownershipPeriod, vehicleOwned, ageFrom,
      ageTo
    )
    if (result?.status) {
      const { items, total } = result.data
      setListData(items)
      setPagination({ current: pageCurent, total: total, pageSize })
    } else {
      pushToast(result?.msg, "warning")
    }
    setLoading(false)
  }, 1000)



  //tìm kiếm
  const onChangeFilterSeach = (e?: string) => {
    setDataFilterList({ ...dataFilterList, searchF: e })
  }

  //Bộ lọc Thêm
  //độ tuổi
  const onChangeFilterAddAge = (value: number[]) => {
    setDataFilterAdd({ ...dataFilterAdd, age: [...value] })
  }

  //gt
  const onChangeFilterAddGender = (e: RadioChangeEvent) => {
    setDataFilterAdd({ ...dataFilterAdd, gender: e.target.value })
  }

  //So lượng xe
  const onChangeFilterAddNumberOwnedCar = (value: number) => {
    if (Number.isInteger(value) && value > -1) {
      if (value === 0)
        setDataFilterAdd({
          ...dataFilterAdd,
          vehicleOwned: undefined
        })
      else
        setDataFilterAdd({
          ...dataFilterAdd
          , vehicleOwned: dataFilterAdd.vehicleOwned === value ? undefined : value
        })

    } else {
      pushToast('Giá trị không hợp lệ. Vui lòng nhập số nguyên không âm.', 'warning');
      setDataFilterAdd({ ...dataFilterAdd, vehicleOwned: undefined });
    }
  }

  //tg sở hữu
  const onChangeFilterAddOwnershipPeriodCar = (value: number) => {
    setDataFilterAdd({
      ...dataFilterAdd,
      ownershipPeriod: dataFilterAdd.ownershipPeriod === value ? undefined : value
    })
  }

  // thuong hiệu
  const onChangeFilterAddCategoryCar = (e: RadioChangeEvent) => {
    setDataFilterAdd({ ...dataFilterAdd, brand: e.target.value })
  };

  // new func filter
  const handleClearFilter = () => {
    setDataFilterAdd(dataDefaulFilterList)
  }

  const handleApplyFilter = async () => {
    setIsModalAddFilter(false)
    setDataFilterList({
      ...dataFilterAdd,
      searchF: undefined, // Thêm trường search
    })
  }
  // end filter

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCustomer(pageNumber, pageSize)
  }


  // Use ref to avoid re-creating debounce/save-cache
  const saveCacheRef = useRef<ReturnType<typeof getSaveCache>>();

  // Debounce saveCache to avoid frequent calls
  function getSaveCache() {
    let timeout: NodeJS.Timeout | null = null;
    let lastArgs: any = null;

    return async (data: any, name: string) => {
      if (Object.keys(data.listData).length === 0) return;
      console.log(data)
      lastArgs = { data, name };
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(async () => {
        const { data, name } = lastArgs;
        const param = {
          user_id_thaco: id,
          name: nameTableCache,
          data_json: JSON.stringify(data),
        };
        await mixPostV2('/api/v1/be/user_thaco_json', param);
      }, 800);
    }
  }
  // Init saveCache on first render
  useEffect(() => {
    saveCacheRef.current = getSaveCache();
  }, [id]);

  // Search
  const { Search } = Input;

  // Row selection
  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };

  // // Pagination
  // const handleChangePagination = (current: number, pageSize: number) => {
  //   setPagination({ ...pagination, current, pageSize });
  //   setParamListData((prev: any) => ({ ...prev, limit: pageSize, page: current }));
  // };

  useEffect(() => {
    setParamListData((prev: any) => ({ ...prev, page: 1 }));
  }, [selectedRowKeys]);

  // // Fetch List Data
  // useEffect(() => {
  //   let ignore = false;
  //   setLoading(true);
  //   let api = `/customers/?skip=${paramListData.page - 1}&limit=${paramListData.limit}`
  //   if (paramListData.keyword) {
  //     api += `&search=${paramListData.keyword}`
  //   }
  //   mixGetV3(api)
  //     .then(res => {
  //       if (!ignore) {
  //         setLoading(false);
  //         if (res.count && res.count !== 0) {
  //           const temp = [] as any;
  //           res.data.forEach((val: any) => {
  //             temp.push({
  //               ...val,
  //               key: val.id,
  //             })
  //           });

  //           setListData(temp);
  //           setPagination((prev) => ({ ...prev, total: res.count }));
  //         } else {
  //           setListData([]);
  //           setPagination((prev) => ({ ...prev, total: 0 }));
  //         }
  //       }
  //     });
  //   return () => { ignore = true; }
  // }, [paramListData]);

  // Delete modal
  const openModalDelete = (id: number) => {
    setIdCustomer(id);
    setOpenDeleteListCustomer(true);
  };
  const closeModalDelete = () => {
    setIdCustomer(undefined);
    setOpenDeleteListCustomer(false);
  };
  const onConfirmDelete = async () => {
    const param = {
      list_ids: idCustomer?.toString()
    };
    // const res = await mixPostV2('/api/v1/be/warehouse_delete', param);
    const res = await mixGetV2('/api/v1/be/elastic/create_index');
    if (res.status) {
      pushToast('Xóa thành công', "success");
      closeModalDelete();
      setSelectedRowKeys([]);
      // Reload list
      setParamListData((prev: any) => ({ ...prev }));
    } else {
      pushToast('Error', "warning");
    }
  };

  // Multi Delete
  const mutiDel = (ids: React.Key[]) => {
    setIdCustomer(ids as any); // type can be array for multi delete
    setOpenDeleteListCustomer(true);
  };

  // Column Data
  useEffect(() => {
    let ignore = false;
    async function getcolumn() {
      const [res, res2] = await Promise.all([
        mixGetV2('/api/v1/be/source_column_warehouses?is_active=1'),
        mixPostV2(`/api/v1/be/user_thaco_json_more`, {
          user_id_thaco: id,
          name: JSON.stringify([nameTableCache]),
        }),
      ]);
      if (!ignore && res.status) {
        matchCols(res.data.items, res2.status && res2.data.items[0] ? JSON.parse(res2.data.items[0].data_json) : {});
      }
    }
    getcolumn();
    return () => { ignore = true; }
    // eslint-disable-next-line
  }, [id]);

  // Match Columns
  const matchCols = useCallback((cols = [], dataJson: any) => {
    const tbCache = dataJson;
    const ob = tbCache.listData || {};

    const temp = [
      {
        headerName: "Hành động",
        field: "hanhdong",
        colId: "hanhdong",
        width: ob['hanhdong'] ? ob['hanhdong'].width : 100,
        pos: ob['hanhdong'] ? ob['hanhdong'].pos : 0,
        hide: ob['hanhdong'] ? ob['hanhdong'].hide : false,
        cellRenderer: (params: any) => (
          <Space size="middle">
            <DeleteOutlined
              className='text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2'
              onClick={() => openModalDelete(Number(params.data.warehouse_id_origin))}
            />
            <EyeOutlined
              className='text-sm border-EAECF0 p-5-px bg-white rounded-2'
              onClick={() => {
                navigate(`/customer/pooling-data/customer-list/${params.data.id}`);
              }}
            />
          </Space>
        )
      },
      {
        headerName: "ID",
        field: "warehouse_id_origin",
        colId: "warehouse_id_origin",
        width: ob['warehouse_id_origin'] ? ob['warehouse_id_origin'].width : 100,
        pos: ob['warehouse_id_origin'] ? ob['warehouse_id_origin'].pos : 0,
        hide: ob['warehouse_id_origin'] ? ob['warehouse_id_origin'].hide : false,
      },
      {
        headerName: "Ngày cập nhật",
        field: "updated_at",
        colId: "updated_at",
        width: ob['updated_at'] ? ob['updated_at'].width : 200,
        pos: ob['updated_at'] ? ob['updated_at'].pos : 0,
        hide: ob['updated_at'] ? ob['updated_at'].hide : false,
      },
    ];

    const firstView = Object.keys(ob).length === 0;
    const notShowCols = temp.map((val: any) => val.field);

    cols.forEach((val: any, index: any) => {
      const item = {
        headerName: val.name,
        field: val.column_warehouse.column,
        colId: val.id,
        width: ob[val.id] ? ob[val.id].width : 100,
        pos: ob[val.id] ? ob[val.id].pos : index,
        hide: firstView && val.is_default === 1 ? false : ob[val.id] ? ob[val.id].hide : true,
        cellRenderer: (params: any) => (
          <div className='table-wrap-text'>{params.value}</div>
        )
      };
      temp.push(item);
    });

    temp.sort((a: any, b: any) => a.pos - b.pos);

    setMegaTableData((prev: any) => ({ ...prev, col: temp, screen: tbCache.screen || window.innerWidth }));
    setTempColData([...temp]);
    if (firstView) {
      setParamListData((prev: any) => ({
        ...prev,
        list_key: JSON.stringify(
          temp.filter((col: any) => col.hide === false && !notShowCols.includes(col.field)).map((col: any) => col.field)
        ),
      }));
    } else {
      setParamListData((prev: any) => ({
        ...prev,
        list_key: JSON.stringify(
          cols.filter(
            (col: any) => !notShowCols.includes(col.column_warehouse.column)
          ).map((col: any) => col.column_warehouse.column)
        ),
      }));
    }
  }, []);

  // Get ParamKeys, ParamMap, Source
  useEffect(() => {
    mixGetV2('/api/v1/be/source_column_warehouses?is_active=1').then(res => {
      if (res.status) {
        const temp = [] as any
        res.data.items.map((val: any) => {
          const listSourceIds = [] as any
          val.params_key.map((val: any) => {
            listSourceIds.push(val.source_id)
            return true
          })
          temp.push({ id: val.id, name: val.name, column: val.column_warehouse.column, source_id: listSourceIds, type: val.type_id })
          return true
        })
        setParamKeys(temp);
      }
    });
  }, []);
  useEffect(() => { mixGetV2('/api/v1/be/setting_mapping?type=2').then(res => res.status && setParamMap(JSON.parse(res.data.value || '[]'))); }, []);
  useEffect(() => { mixGetV2('/api/v1/be/sources').then(res => res.status && setSource(res.data.items)); }, []);

  // MegaTable onChange
  const handleMegaTableChange = useCallback((data: any, type: string) => {
    setTempColData([...data]);
    if (type === 'colChange') {
      const temp: any = {};
      data.forEach((val: any, index: any) => {
        temp[val.colId] = {
          colId: val.colId,
          field: val.field,
          headerName: val.headerName,
          hide: val.hide || false,
          width: val.width,
          pos: index,
        };
      });
      const newCache = { listData: temp, screen: window.innerWidth };
      saveCacheRef.current && saveCacheRef.current(newCache, nameTableCache);
    }
    if (type === 'onSelectedRows') {
      setSelectedRowKeys(data);
    }
  }, []);

  // ColSetting onChange
  const handleColSettingChange = useCallback((data: any, type: string) => {
    if (type === 'close') {
      setMegaTableData((prev: any) => ({ ...prev, open: false }));
    }
    if (type === 'saveChange') {
      setMegaTableData((prev: any) => ({ ...prev, col: data, open: false }));
      setTempColData([...data]);
      let temp: any = {};
      const listFields: any[] = [];
      data.forEach((val: any, index: any) => {
        temp[val.colId] = {
          ...val,
          pos: index,
        };
        if (!val.hide && val.field !== 'hanhdong' && val.field !== 'warehouse_id_origin') {
          listFields.push(val.field);
        }
      });
      const newCache = { listData: temp, screen: window.innerWidth };
      saveCacheRef.current && saveCacheRef.current(newCache, nameTableCache);
      if (listFields.length > 0) {
        setParamListData((prev: any) => ({
          ...prev,
          list_key: JSON.stringify(listFields),
        }));
      }
    }
  }, []);

  // Render logic
  const hasSelected = selectedRowKeys.length > 0;

  useEffect(() => {
    if (isModalAddFilter) {
      if (!sLCarCompany.length)
        gSLVehicleBrands()
      setDataFilterAdd(dataFilterList)
    }

  }, [isModalAddFilter])

  useEffect(() => {
    gListCustomer()
  }, [dataFilterList])

  return (
    <>
      <Layout className='customer-list'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link> },
            { title: 'Khách hàng' },
            { title: 'Danh sách khách hàng' },
          ]}
          title='Danh sách khách hàng'
          backLink='/customer/pooling-data'
          className='gutter-block-end'
        />

        {/* Bộ lọc QuangAA */}
        <div className={`add-filter ${isModalAddFilter ? "active" : ""}`}>

          <div className="title-add-filter title-popup-add-filter">
            <div className="text">Bộ lọc</div>
            <div className="setting-icon"
            //  onClick={handleSettingShowAddFilter}
            >
              <div className="text">Tùy chỉnh</div>
              <div className="icon">
                <SettingOutlined />
              </div>
            </div>
          </div>

          <div className="content-add-filter t-scrollbar">
            <div className="col-add-filter">
              <div className="one-add-filter-block t-mb-24 t-scrollbar">
                <div className="col-title-add-filter">Độ tuổi</div>
                <div className="list-add-filter-content slider-price">
                  <Slider
                    min={0}
                    max={100}
                    range
                    marks={dotuoi}
                    tooltip={{ open: false }}
                    value={dataFilterAdd.age}
                    onChange={onChangeFilterAddAge}
                  />
                </div>
              </div>
              <div className="one-add-filter-block t-mb-24">
                <div className="col-title-add-filter">Giới tính</div>
                <div className="list-select-2col">
                  <Radio.Group
                    className='custom-option'
                    value={dataFilterAdd.gender}
                    onChange={onChangeFilterAddGender}
                  >
                    {
                      dataGender?.map((item, i) =>
                        <Radio
                          key={i}
                          className="one-add-filter-content"
                          value={item.title}>
                          <div className="text">{item.title}</div>
                        </Radio>
                      )
                    }

                  </Radio.Group>
                </div>
              </div>

            </div>
            <div className="col-add-filter">


              <div className=" t-mb-24">
                <div className="col-title-add-filter">Số lượng xe sở hữu</div>
                <div className='t-search-block t-mt-12 pr-28-px'>
                  <Input
                    placeholder="Nhập số lượng"
                    className='rs-input'
                    type='number'
                    value={dataFilterAdd.vehicleOwned}
                    onChange={(e) => onChangeFilterAddNumberOwnedCar(Number(e.target.value))}
                  />
                </div>
                <div className="d-flex flex-wrap">
                  <label className="custom-checkbox w-half">
                    <input
                      type="checkbox"
                      value={1}
                      checked={dataFilterAdd.vehicleOwned === 1}
                      onChange={(e) => onChangeFilterAddNumberOwnedCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>1</span>
                  </label>

                  <label className="custom-checkbox w-half">
                    <input
                      type="checkbox"
                      value={2}
                      checked={dataFilterAdd.vehicleOwned === 2}
                      onChange={(e) => onChangeFilterAddNumberOwnedCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>2</span>
                  </label>

                  <label className="custom-checkbox w-half pt-2">
                    <input
                      type="checkbox"
                      value={3}
                      checked={dataFilterAdd.vehicleOwned === 3}
                      onChange={(e) => onChangeFilterAddNumberOwnedCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>3</span>
                  </label>
                  <label className="custom-checkbox w-half pt-2">
                    <input
                      type="checkbox"
                      value={4}
                      checked={dataFilterAdd.vehicleOwned === 4}
                      onChange={(e) => onChangeFilterAddNumberOwnedCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>4</span>
                  </label>
                </div>
              </div>

              {/* <div className="d-flex flex-column gap-3">
                <div className="col-title-add-filter">Thời gian sở hữu xe</div>
                <div className="d-flex flex-wrap">
                  <label className="custom-checkbox w-half">
                    <input
                      type="checkbox"
                      value={0}
                      checked={dataFilterAdd.ownershipPeriod === 0}
                      onChange={(e) => onChangeFilterAddOwnershipPeriodCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>Dưới 1 năm</span>
                  </label>

                  <label className="custom-checkbox w-half">
                    <input
                      type="checkbox"
                      value={1}
                      checked={dataFilterAdd.ownershipPeriod === 1}
                      onChange={(e) => onChangeFilterAddOwnershipPeriodCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>1 - 3 năm</span>
                  </label>

                  <label className="custom-checkbox w-half pt-2">
                    <input
                      type="checkbox"
                      value={2}
                      checked={dataFilterAdd.ownershipPeriod === 2}
                      onChange={(e) => onChangeFilterAddOwnershipPeriodCar(Number(e.target.value))}
                    />
                    <span className="checkmark"></span> <span className='text-sm text-667085'>Trên 3 năm</span>
                  </label>
                </div>
              </div> */}
            </div>

            <div className="col-add-filter">
              <div className="t-mb-24 t-scrollbar h-full">
                <div className="col-title-add-filter">Thương hiệu sở hữu</div>
                <div className="list-view-filter-content">
                  <Radio.Group
                    className='custom-option gap-1'
                    value={dataFilterAdd.brand}
                    options={sLCarCompany}
                    onChange={onChangeFilterAddCategoryCar}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="footer-filter-block">
            <div className="btn-block">
              <div className="btn btn-df"
                onClick={handleClearFilter}
              >
                <div className="icon-svg"><DeleteOutlined /></div>
                <div className="text">
                  Làm mới
                </div>
              </div>

              <div className="btn btn-primary"
                onClick={handleApplyFilter}
              >
                <div className="icon-svg"><FilterOutlined /></div>
                <div className="text">
                  Áp dụng lọc
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filter block */}
        <div className={`filter-block ${hasSelected ? "active" : ""}`}>
          <div className='t-search-block'>
            <Search
              placeholder="Tìm kiếm"
              value={dataFilterList.searchF}
              onChange={(e) => onChangeFilterSeach(e.target.value)}
            />
          </div>
          <div className='filter-select'>
            <div
              className='btn-select-show'
            >
              <span
                className="content-select"
                onClick={() => setIsModalAddFilter(true)} >
                {'Bộ lọc'}
              </span>
              <div
                className={`icon-down ${isModalAddFilter ? "active" : ""}`}
                onClick={() => setIsModalAddFilter(true)}
              >
                <DownOutlined />
              </div>
              <div
                className={`icon-close ${isModalAddFilter ? "active" : ""}`}
                onClick={() => handleClearFilter()}
              >
                <CloseCircleOutlined />
              </div>
            </div>

          </div>
          <div className="btn-input" onClick={() => navigate('/customer/pooling-data/import-data')}>
            <div className="icon-svg"><UploadOutlined /></div>
            <div className="text">Nhập DS</div>
          </div>
          {/* <div className="btn-input t-px-8" onClick={() => setMegaTableData((prev: any) => ({ ...prev, open: true, col: tempColData }))}>
            <div className="icon-svg"><SettingOutlined /></div>
          </div> */}
        </div>

        {/* Filter block for selected */}
        <div className={`filter-block filter-active-show ${hasSelected ? "active" : ""}`}>
          <div className='total-chosse'>
            {hasSelected ? `Đã chọn ${selectedRowKeys.length} khách hàng` : ''}
          </div>
          <div className="btn-input" onClick={() => { mutiDel(selectedRowKeys) }}>
            <div className="icon-svg"><DeleteOutlined /></div>
            <div className="text">{`Xóa ${selectedRowKeys.length} khách hàng`}</div>
          </div>
        </div>

        <div className='megatable'>
          <Table
            columns={columns}
            dataSource={listData}
            showSorterTooltip={false}
            rowKey="id"
            className="rs-table"
            pagination={false}
            scroll={{ x: 'max-content' }}
          />
        </div>

        <div className="t-table-block t-table-customer c-table-scoll-x">
          <div className="pagination-block">
            <Pagination
              className='rs-pagination'
              showSizeChanger
              total={pagination.total}
              defaultPageSize={pagination.pageSize}
              current={pagination.current}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={() => `Tổng cộng ${Math.ceil(pagination.total / pagination.pageSize) === 0 ? 1 : Math.ceil(pagination.total / pagination.pageSize)} trang`}
              locale={{ items_per_page: 'trang' }}
              onChange={onPaginationChange}
            />
          </div>
        </div>

        <ColSetting
          stData={{ ...megaTableData }}
          onChange={handleColSettingChange}
        />
      </Layout>

      <ModalDeleteManager
        isOpen={openDeleteListCustomer}
        title="Bạn có chắc chắn xóa khách hàng này"
        titleDelete="Xóa khách hàng"
        content="Khách hàng và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />

      {/* MODAL IMPORT DATA */}
      <ImportDataModal
        show={showImportDataModal}
        columns={paramKeys}
        source={source}
        paramMap={paramMap}
        paramKeysChange={() => {
          mixGetV2('/api/v1/be/source_column_warehouses?is_active=1').then(res => {
            if (res.status) {
              const temp = [] as any
              res.data.items.map((val: any) => {
                const listSourceIds = [] as any
                val.params_key.map((val: any) => {
                  listSourceIds.push(val.source_id)
                  return true
                })
                temp.push({ id: val.id, name: val.name, column: val.column_warehouse.column, source_id: listSourceIds, type: val.type_id })
                return true
              })
              setParamKeys(temp);
            }
          });
        }}
        paramMapChange={() => mixGetV2('/api/v1/be/setting_mapping?type=2').then(res => res.status && setParamMap(JSON.parse(res.data.value || '[]')))}
        modalClose={() => {
          setShowImportDataModal(false);
          setParamListData((prev: any) => ({ ...prev }));
        }}
      />
    </>
  );
};

export default CustomerList;
